import api, { ApiResponse } from './api';

export interface Device {
  id: number;
  deviceId: number;
  deviceName: string;
  deviceCode?: string;
  ipAddress: string;
  port: number;
  locationId?: number;
  location?: string;
  deviceType?: string;
  protocol?: string; // ZKTeco, Optex
  isActive: boolean;
  isOnline: boolean;
  lastSyncTime?: string;
  lastConnectionTime?: string;
  serialNumber?: string;
  model?: string;
  macAddress?: string;
  currentUsers?: number;
  createdDate?: string;
}

export interface DeviceCreateDto {
  deviceName: string;
  deviceCode?: string;
  ipAddress: string;
  port?: number;
  locationId?: number;
  location?: string;
  deviceType?: string;
  protocol?: string; // ZKTeco, Optex
  serialNumber?: string;
  model?: string;
  macAddress?: string;
}

export interface DeviceUpdateDto {
  deviceName?: string;
  deviceCode?: string;
  ipAddress?: string;
  port?: number;
  locationId?: number;
  location?: string;
  deviceType?: string;
  protocol?: string; // ZKTeco, Optex
  serialNumber?: string;
  model?: string;
  macAddress?: string;
  isActive?: boolean;
}

export interface DeviceStats {
  total: number;
  online: number;
  offline: number;
  active: number;
}

export interface PingResult {
  deviceId: number;
  deviceName: string;
  ipAddress: string;
  isOnline: boolean;
  latency: number;
  checkedAt: string;
}

export interface ImportUsersResult {
  totalOnDevice: number;
  imported: number;
  skipped: number;
  importedUsers: string[];
  errors: string[];
}

const deviceService = {
  getAll: async (): Promise<ApiResponse<Device[]>> => {
    return api.get('/devices');
  },

  getById: async (id: number): Promise<ApiResponse<Device>> => {
    return api.get(`/devices/${id}`);
  },

  create: async (data: DeviceCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/devices', data);
  },

  update: async (id: number, data: DeviceUpdateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/devices/${id}`, data);
  },

  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/devices/${id}`);
  },

  ping: async (id: number): Promise<ApiResponse<PingResult>> => {
    return api.post(`/devices/${id}/ping`);
  },

  getOnline: async (): Promise<ApiResponse<Device[]>> => {
    return api.get('/devices/online');
  },

  getStats: async (): Promise<ApiResponse<DeviceStats>> => {
    return api.get('/devices/stats');
  },

  importUsers: async (id: number): Promise<ApiResponse<ImportUsersResult>> => {
    return api.post(`/devices/${id}/import-users`);
  },
};

export default deviceService;
